import { Link } from 'react-router-dom'
import { ArrowLeft, Sparkles, PencilLine, ChevronRight, Ship, CarFront, type LucideIcon } from 'lucide-react'

export function CreateTripPicker() {
  return (
    <div className="mx-auto max-w-xl">
      <Link
        to="/"
        className="mb-4 inline-flex items-center gap-1 text-sm text-st-muted hover:text-st-text"
      >
        <ArrowLeft className="h-4 w-4" /> Back to trips
      </Link>

      <h1 className="font-display text-2xl font-bold text-st-text">Create a trip</h1>
      <p className="mt-1 text-sm text-st-muted">
        Let the assistant draft a route, or start from a blank plan.
      </p>

      <div className="mt-6 space-y-3">
        <ModeCard
          to="/trips/new/ai"
          Icon={Sparkles}
          title="Plan with AI"
          description="Describe your trip in a sentence — we’ll draft an itinerary you can edit."
          recommended
        />
        <ModeCard
          to="/trips/new/manual"
          Icon={PencilLine}
          title="Build manually"
          description="Start with a title and dates, then add places yourself."
        />
        <ModeCard
          to="/trips/new/template/cruise"
          Icon={Ship}
          title="Cruise template"
          description="Pre-built port-day skeleton — embark, excursions, disembark."
        />
        <ModeCard
          to="/trips/new/template/road-trip"
          Icon={CarFront}
          title="Road trip template"
          description="Multi-stop driving loop with pick-up, viewpoints, and overnights."
        />
      </div>
    </div>
  )
}

function ModeCard({
  to,
  Icon,
  title,
  description,
  recommended,
}: {
  to: string
  Icon: LucideIcon
  title: string
  description: string
  recommended?: boolean
}) {
  return (
    <Link
      to={to}
      className="flex items-center gap-4 rounded-st-lg border border-st-line bg-st-surface p-4 transition hover:border-st-primary hover:bg-st-surface-2"
    >
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-st-md bg-st-surface-2 text-st-primary">
        <Icon className="h-5 w-5" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2">
          <span className="font-medium text-st-text">{title}</span>
          {recommended && (
            <span className="rounded-st-full bg-st-accent/15 px-2 py-0.5 text-xs font-medium text-st-accent-700">
              Recommended
            </span>
          )}
        </span>
        <span className="mt-0.5 block text-sm text-st-muted">{description}</span>
      </span>
      <ChevronRight className="h-5 w-5 shrink-0 text-st-muted" />
    </Link>
  )
}
